// Description: Page that render the integrations page
// Updated: 18/09/2025
// Author: Simon Franklin

// React
import { useEffect, useState } from "react";

// Material UI Components
import { Box, Skeleton } from "@mui/material";
import Titles from "../../components/Titles/Titles";

// Components and functions for the project
import HeaderPage from "../../components/HeaderPage/HeaderPage";
import { consultIntegrations } from "../../api/aws/Integrations/listIntegrations";
import { useNavigate } from "react-router-dom";
import use123zapStore from "../../context/123zapStore";
import CardListG from "../../components/CardList/CardListG";
import Footer from "../../components/Footer/Footer";

// Render The Page
const IntegrationsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("Todos");
  const integrations = use123zapStore((state) => state.integrations);
  const setIntegrations = use123zapStore((state) => state.setIntegrations);
  const alreadyFetchIntegrations = use123zapStore(
    (state) => state.alreadyFetchIntegrations
  );
  const setAlreadyFetchIntegrations = use123zapStore(
    (state) => state.setAlreadyFetchIntegrations
  );
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const filteredIntegrations = integrations.filter(
    (item) => selectedCategory === "Todos" || item.category === selectedCategory
  );

  useEffect(() => {
    (async () => {
      if (!alreadyFetchIntegrations) {
        setLoading(true);
        consultIntegrations()
          .then((response) => setIntegrations(response.data))
          .finally(() => {
            setLoading(false);
            setAlreadyFetchIntegrations(true);
          });
      }
    })();
  }, []);

  const goToAddIntegrationPage = (id) => {
    localStorage.setItem("integration_id", id);
    navigate("/integrações/adicionar");
  };

  const handleRequestIntegration = () => {
    window.open("https://wa.me/5599999999999", "_blank");
  };

  return (
    <>
      <HeaderPage title="Add WhatsApp Instance" />
      <Box
        sx={{
          position: "relative",
          width: "100%",
          minHeight: { sm: "calc(100vh - 100px)" },
        }}
      >
        <Box sx={{ padding: { xs: "20px", sm: "32px" } }}>
          <Titles
            styles={{ fontSize: { xs: "20px", sm: "24px" } }}
            children={"Selecione sua integração para criar as listagens"}
            color={"#848484"}
          />
          <CardListG
            data={[
              ...filteredIntegrations.map((item) => ({
                title: item.title,
                subtitle: item.category,
                text: item.description,
                icon: item.logo,
                iconColor: null,
                onClick: () => goToAddIntegrationPage(item.id),
                alreadyPaid: true,
                heightIcon: "32px",
                pago: true,
              })),
              {
                title: "Solicitar integração",
                subtitle: "Não encontrou sua integração?",
                text: "Clique aqui para solicitar que adicionemos via WhatsApp.",
                icon: "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg", // exemplo de ícone
                iconColor: "#25D366",
                onClick: () =>
                  window.open(
                    "https://wa.me/553121300297?text=Ol%C3%A1%2C%20estou%20precisando%20de%20suporte!%209",
                    "_blank"
                  ), // link do WhatsApp
                alreadyPaid: true,
                heightIcon: "32px",
                pago: true,
              },
            ]}
            loading={loading}
            showText={true}
          />
          <div style={{ padding: "40px 0 0 0", marginTop: "auto" }}>
            <Footer />
          </div>
        </Box>
      </Box>
    </>
  );
};

export default IntegrationsPage;
